import { ThemeEvents } from '@theme/events';

/**
 * Updates the product form from variant data already embedded in the page.
 * Shopify's section response still follows and remains authoritative for
 * inventory rules, media, pricing, and the final button markup.
 */
document.addEventListener(ThemeEvents.variantSelected, (event) => {
  const picker = event.target;
  const variant = event.detail?.resource;

  if (!(picker instanceof HTMLElement) || picker.tagName !== 'VARIANT-PICKER') return;
  if (!variant?.id || typeof variant.available !== 'boolean') return;

  queueMicrotask(() => {
    const scope = picker.closest('.shopify-section, dialog, product-card');
    const productId = picker.dataset.productId;
    if (!scope || !productId) return;

    const productForm = scope.querySelector(`product-form-component[data-product-id="${productId}"]`);
    if (!(productForm instanceof HTMLElement)) return;

    const variantId = productForm.querySelector('input[name="id"]');
    const addToCart = productForm.querySelector('add-to-cart-component');
    if (!(variantId instanceof HTMLInputElement) || !(addToCart instanceof HTMLElement)) return;

    variantId.value = String(variant.id);

    if (variant.available) {
      addToCart.enable?.();
    } else {
      addToCart.disable?.();
    }
  });
});
